import { useCallback, useEffect } from "react";
import {
  PUSH_RECEIVED_EVENT,
  acquireNotificationSync,
  loadMoreNotifications,
  loadNotifications,
  markAllNotificationsAsRead,
  markNotificationsAsRead,
  refreshCount,
  setNotificationFilter,
  useNotificationState,
} from "../services/notificationState";

export { PUSH_RECEIVED_EVENT };

/**
 * React access to the shared notification store (unread badge + unified feed with mark-read).
 * `enabled` = user is logged in. While enabled, this component participates in the single shared background sync.
 * Every component using this hook sees the same data, so the bell and the dashboard card always agree.
 */
export function useNotifications(enabled: boolean) {
  const s = useNotificationState();

  useEffect(() => {
    if (!enabled) return undefined;
    return acquireNotificationSync();
  }, [enabled]);

  const load = useCallback(() => (enabled ? loadNotifications() : Promise.resolve()), [enabled]);
  const loadMore = useCallback(() => (enabled ? loadMoreNotifications() : Promise.resolve()), [enabled]);

  return {
    unread: enabled ? s.unread : 0,
    items: enabled ? s.items : [],
    loading: s.loading,
    loaded: s.loaded,
    countReady: s.countReady,
    hasMore: Boolean(s.nextBefore),
    filter: s.filter,
    load,
    loadMore,
    setFilter: setNotificationFilter,
    markRead: markNotificationsAsRead,
    markAllRead: markAllNotificationsAsRead,
    refreshCount,
  };
}

export default useNotifications;
